export interface CustomThemeInterface {
    body: string;
    background: string;
    themeType: string;
    navColor: string;
  }


export const lightTheme: CustomThemeInterface = {
    themeType: 'light',
    body: 'black',
    background: 'white',
    navColor: '#879AE4'

}
export const darkTheme: CustomThemeInterface = {
    themeType: 'dark',
    body: 'white',
    background: 'black',
    navColor: '#231452'
}
